bcl.s.dataAnchor = {
  props: {
    offset: -100,
    classTabPanel: "cmp-tabs__tabpanel",
    classTab: "cmp-tabs__tab",
    classTabActive: "cmp-tabs__tab--active",
    scrollController: null,
    prepareNavigation: null,
    layoutQuietWindow: 250,
    layoutTrackingTimeout: 4000,
    scrollTolerance: 2,
    retargetThreshold: 24,
    maxScrollCorrections: 2,
    initialAnchorHandled: false,
    initialAnchorEventsBound: false,
  },

  init: function (baseDom) {
    const baseFind = baseDom ? baseDom : document;

    const components = baseFind.querySelectorAll('a[href^="#"]');

    bcl.u.forEach(components, function ($component) {
      const href = bcl.s.dataAnchor.getHref($component);

      if (href && $component.dataset.dataAnchorBound !== "true") {
        $component.dataset.dataAnchorBound = "true";
        $component.addEventListener("click", function (event) {
          event.preventDefault();

          if ($component.hash && window.location.hash !== $component.hash) {
            window.history.pushState(null, "", $component.hash);
          }

          bcl.s.dataAnchor.clickAnchor(bcl.s.dataAnchor.getHref($component), bcl.s.dataAnchor.props.offset, {
            trigger: $component,
          });
        });
      }
    });

    if (!bcl.s.dataAnchor.props.initialAnchorEventsBound) {
      bcl.s.dataAnchor.props.initialAnchorEventsBound = true;
      const handleInitialAnchor = function () {
        if (bcl.s.dataAnchor.props.initialAnchorHandled) {
          return;
        }
        bcl.s.dataAnchor.props.initialAnchorHandled = true;
        bcl.s.dataAnchor.isAnchor();
      };

      document.addEventListener("bcl-base-components-loaded", handleInitialAnchor, { once: true });
      window.addEventListener("preInitLoaded", handleInitialAnchor, { once: true });
    }
  },

  isAnchor: function () {
    const url = window.location.hash;

    if (url) {
      bcl.s.dataAnchor.clickAnchor(url.replace("#", ""), bcl.s.dataAnchor.props.offset);
    }
  },

  getHref: function ($component) {
    const hrefSplit = $component.href.split("#");

    if (hrefSplit.length == 2) {
      return hrefSplit[1];
    }
  },

  clickAnchor: function (valueAnchor, offset, options) {
    const $node = bcl.s.dataAnchor.getNodeAnchor(valueAnchor);

    if ($node) {
      const $parent = bcl.u.getParent($node, bcl.s.dataAnchor.props.classTabPanel);
      if (bcl.u.containsClass($parent, bcl.s.dataAnchor.props.classTabPanel)) {
        for (let i = 0; i < document.getElementsByClassName(bcl.s.dataAnchor.props.classTabPanel).length; i++) {
          const $tabPanel = document.getElementsByClassName(bcl.s.dataAnchor.props.classTabPanel)[i];
          const $tab = document.getElementsByClassName(bcl.s.dataAnchor.props.classTab)[i];
          if ($tabPanel === $parent && !bcl.u.containsClass($tab, bcl.s.dataAnchor.props.classTabActive)) {
            bcl.u.triggerEvent($tab, "click");
          }
        }
      }
      bcl.s.dataAnchor.goToScrollAnchor($node, offset, options);
    }
  },

  setPrepareNavigation: function (prepareNavigation) {
    this.props.prepareNavigation = typeof prepareNavigation === "function" ? prepareNavigation : null;
  },

  goToScrollAnchor: async function ($node, offset, options) {
    if (!$node || document.querySelector("html")?.dataset?.template === "mybarcelo") {
      return;
    }

    this.cancelScroll();

    const parsedOffset = Number(offset);
    const controller = {
      node: $node,
      offset: Number.isFinite(parsedOffset) ? parsedOffset : 0,
      abortController: typeof AbortController === "function" ? new AbortController() : null,
      cancelled: false,
      cleanup: null,
      trigger: options?.trigger || null,
      layoutObserver: null,
      correctionFrame: null,
      quietTimer: null,
      scrollQuietTimer: null,
      deadlineTimer: null,
      finalTimer: null,
      lastTargetTop: null,
      commandedTop: null,
      layoutQuiet: false,
      scrollQuiet: false,
      correctionCount: 0,
      scrollHandler: null,
      previousRootOverflowAnchor: document.documentElement.style.overflowAnchor,
      previousBodyOverflowAnchor: document.body?.style.overflowAnchor || "",
    };

    const cancelOnUserInput = (event) => {
      if (event.type === "keydown" && !["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", " "].includes(event.key)) {
        return;
      }

      this.cancelScroll(controller);
    };

    const passiveOptions = { passive: true };
    window.addEventListener("wheel", cancelOnUserInput, passiveOptions);
    window.addEventListener("touchstart", cancelOnUserInput, passiveOptions);
    window.addEventListener("pointerdown", cancelOnUserInput, passiveOptions);
    window.addEventListener("keydown", cancelOnUserInput);

    controller.cleanup = () => {
      window.removeEventListener("wheel", cancelOnUserInput, passiveOptions);
      window.removeEventListener("touchstart", cancelOnUserInput, passiveOptions);
      window.removeEventListener("pointerdown", cancelOnUserInput, passiveOptions);
      window.removeEventListener("keydown", cancelOnUserInput);
      window.removeEventListener("scroll", controller.scrollHandler, passiveOptions);
      controller.layoutObserver?.disconnect();
      if (controller.correctionFrame) {
        window.cancelAnimationFrame(controller.correctionFrame);
      }
      window.clearTimeout(controller.quietTimer);
      window.clearTimeout(controller.scrollQuietTimer);
      window.clearTimeout(controller.deadlineTimer);
      window.clearTimeout(controller.finalTimer);
      document.documentElement.style.overflowAnchor = controller.previousRootOverflowAnchor;
      if (document.body) {
        document.body.style.overflowAnchor = controller.previousBodyOverflowAnchor;
      }
      controller.trigger?.removeAttribute("aria-busy");
      controller.trigger?.classList.remove("is-anchor-preparing");
    };

    this.props.scrollController = controller;
    document.documentElement.style.overflowAnchor = "none";
    if (document.body) {
      document.body.style.overflowAnchor = "none";
    }
    controller.trigger?.setAttribute("aria-busy", "true");
    controller.trigger?.classList.add("is-anchor-preparing");

    try {
      await this.props.prepareNavigation?.(controller.node, {
        signal: controller.abortController?.signal,
      });
    } catch (error) {
      if (error?.name !== "AbortError") {
        console.error("[dataAnchor] Failed to prepare anchor navigation:", error);
      }
    }

    if (controller.cancelled || this.props.scrollController !== controller || !controller.node.isConnected) {
      this.cancelScroll(controller);
      return;
    }

    const targetTop = this.getTargetScrollTop(controller.node, controller.offset);
    const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    bcl.u.goToWithScroll({
      top: targetTop,
      behavior: reducedMotion ? "auto" : "smooth",
    });
    controller.lastTargetTop = targetTop;
    controller.commandedTop = targetTop;
    this.trackTargetPosition(controller, reducedMotion);
  },

  trackTargetPosition: function (controller, reducedMotion) {
    const correctOrFinish = (force) => {
      if (controller.cancelled || this.props.scrollController !== controller || !controller.node.isConnected) {
        this.cancelScroll(controller);
        return;
      }

      if (!force && !controller.layoutQuiet) {
        return;
      }

      const targetTop = this.getTargetScrollTop(controller.node, controller.offset);
      const currentTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
      const distance = Math.abs(targetTop - currentTop);
      const targetDrift = Math.abs(targetTop - controller.commandedTop);

      controller.lastTargetTop = targetTop;
      if (distance <= this.props.scrollTolerance) {
        if (controller.scrollQuiet || force) {
          this.finishScroll(controller);
        }
        return;
      }

      if (!force && !controller.scrollQuiet && targetDrift < this.props.retargetThreshold) {
        return;
      }

      if (controller.correctionCount >= this.props.maxScrollCorrections) {
        window.scrollTo(0, targetTop);
        this.finishScroll(controller);
        return;
      }

      controller.correctionCount += 1;
      controller.scrollQuiet = false;
      controller.commandedTop = targetTop;
      bcl.u.goToWithScroll({
        top: targetTop,
        behavior: reducedMotion ? "auto" : "smooth",
      });

      if (reducedMotion) {
        this.finishScroll(controller);
      }
    };

    const scheduleLayoutQuiet = () => {
      controller.layoutQuiet = false;
      window.clearTimeout(controller.quietTimer);
      controller.quietTimer = window.setTimeout(() => {
        controller.layoutQuiet = true;
        correctOrFinish(false);
      }, this.props.layoutQuietWindow);
    };

    const updateTarget = () => {
      controller.correctionFrame = null;
      if (controller.cancelled || this.props.scrollController !== controller || !controller.node.isConnected) {
        this.cancelScroll(controller);
        return;
      }

      const targetTop = this.getTargetScrollTop(controller.node, controller.offset);
      controller.lastTargetTop = targetTop;
      scheduleLayoutQuiet();
    };

    const scheduleCorrection = () => {
      controller.layoutQuiet = false;
      window.clearTimeout(controller.quietTimer);
      if (!controller.correctionFrame) {
        controller.correctionFrame = window.requestAnimationFrame(updateTarget);
      }
    };

    controller.scrollHandler = () => {
      controller.scrollQuiet = false;
      window.clearTimeout(controller.scrollQuietTimer);
      controller.scrollQuietTimer = window.setTimeout(() => {
        controller.scrollQuiet = true;
        correctOrFinish(false);
      }, 180);
    };
    window.addEventListener("scroll", controller.scrollHandler, { passive: true });

    if (typeof ResizeObserver === "function") {
      controller.layoutObserver = new ResizeObserver(scheduleCorrection);
      controller.layoutObserver.observe(document.documentElement);
      if (document.body) {
        controller.layoutObserver.observe(document.body);
      }
    }

    controller.deadlineTimer = window.setTimeout(() => {
      controller.layoutObserver?.disconnect();
      controller.layoutQuiet = true;
      controller.scrollQuiet = true;
      correctOrFinish(true);
      if (this.props.scrollController === controller) {
        controller.finalTimer = window.setTimeout(() => {
          if (this.props.scrollController !== controller || !controller.node.isConnected) {
            return;
          }
          window.scrollTo(0, this.getTargetScrollTop(controller.node, controller.offset));
          this.finishScroll(controller);
        }, 1200);
      }
    }, this.props.layoutTrackingTimeout);
    controller.scrollHandler();
    scheduleLayoutQuiet();
  },

  getTargetScrollTop: function ($node, offset) {
    const documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    const maxScrollTop = Math.max(0, documentHeight - window.innerHeight);
    const targetTop = this.getScrollTop($node) + offset;

    return Math.min(maxScrollTop, Math.max(0, targetTop));
  },

  finishScroll: function (controller) {
    controller.cleanup?.();
    if (this.props.scrollController === controller) {
      this.props.scrollController = null;
    }
  },

  cancelScroll: function (controller) {
    const activeController = controller || this.props.scrollController;

    if (!activeController) {
      return;
    }

    activeController.cancelled = true;
    activeController.abortController?.abort();
    activeController.cleanup?.();

    if (this.props.scrollController === activeController) {
      this.props.scrollController = null;
    }
  },

  getScrollTop: function ($node) {
    const rect = $node.getBoundingClientRect();
    return rect.top + (window.scrollY || document.documentElement.scrollTop);
  },

  getNodeAnchor: function (valueAnchor) {
    const escapedAnchor = window.CSS?.escape ? window.CSS.escape(valueAnchor) : valueAnchor.replace(/["\\]/g, "\\$&");
    return document.querySelector('[data-anchor="' + escapedAnchor + '"]');
  },
};

bcl.u.docReady(bcl.s.dataAnchor.init, true);
